var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "flex flex-col items-center text-base font-normal"
  }, [_c('div', {
    staticClass: "mb-4 uppercase text-base leading-6 tracking-widest"
  }, [_vm._v("\n\t\t" + _vm._s(['Monthly', 'Annual'][_vm.billingCycle]) + " Membership\n\t")]), _vm._v(" "), _vm.plan.discount[_vm.billingCycle] ? _c('div', {
    staticClass: "discount--pill"
  }, [_vm._v("\n\t\tNow " + _vm._s(_vm.plan.discount[_vm.billingCycle]) + "% Off\n\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "text-center text-2xl"
  }, [_c('span', {
    staticClass: "text-4xl"
  }, [_vm._v("$" + _vm._s(_vm.plan.price[_vm.billingCycle]))]), _vm._v(" "), _vm.plan.displayOnlyFullPrice[_vm.billingCycle] ? _c('span', {
    staticClass: "discount--amount"
  }, [_vm._v("$" + _vm._s(_vm.plan.displayOnlyFullPrice[_vm.billingCycle]))]) : _vm._e(), _c('span', [_vm._v("/" + _vm._s(_vm.billingCycle === 0 ? 'month' : 'year'))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };